import { proxy } from "valtio";
import { EngagementService } from "@services/engagements/engagementService";
import type { SetupStatusItem } from "@services/engagements/commands/cmdGetEngagementSetupStatus";

/*
    Holds the backend setup-status payload. Valtio because the sidebar,
    overview, and item headers all subscribe to it from distant parts of
    the tree. The payload is replaced wholesale on refetch — the backend
    is the only author of item status.
*/
export const workflowStore = proxy<{
  engagementId: number | null;
  statusByKey: Record<string, SetupStatusItem>;
  loadFailed: boolean;
  isLoading: boolean;
}>({
  engagementId: null,
  statusByKey: {},
  loadFailed: false,
  isLoading: false,
});

let latestRequest = 0;

export async function refreshSetupStatus(engagementId: number) {
  const token = ++latestRequest;
  if (workflowStore.engagementId !== engagementId) {
    workflowStore.engagementId = engagementId;
    workflowStore.statusByKey = {};
  }
  workflowStore.isLoading = true;
  try {
    const service = new EngagementService();
    const response = await service.getSetupStatus(engagementId);
    if (token !== latestRequest) return;
    workflowStore.engagementId = engagementId;
    workflowStore.statusByKey = Object.fromEntries(
      response.items.map((item) => [item.key, item])
    );
    workflowStore.loadFailed = false;
  } catch (error) {
    if (token !== latestRequest) return;
    console.error("Get setup status:", error);
    workflowStore.loadFailed = true;
  } finally {
    if (token === latestRequest) workflowStore.isLoading = false;
  }
}
